import { axiosInstance } from '../api';

export default function(studyId) {
    return axiosInstance.get(`/api/study/${studyId}/interested/csv`, { responseType: 'blob'})
        .then(function(response) {
            return window.URL.createObjectURL(response.data);
        }).catch(function(error) {
            // no need to do anything here for now
        });
}